module.exports = __webpack_public_path__ + "img/Profil_VP-Ecoi_Stahl.faf64948.jpg";